import { CATEGORIES, getIcon } from "../lib/icons";
import { useLang } from "../lib/i18n";

export default function Categories({ onPick }) {
  const { t } = useLang();
  return (
    <section id="categories" className="py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
          <div>
            <span className="text-xs font-semibold tracking-[0.2em] text-slate-500">{t("categories.tag")}</span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold mt-2">
              {t("categories.title_pre")} <span style={{ color: "var(--pm-dog)" }}>{t("categories.title_word")}</span>
            </h2>
          </div>
          <p className="text-sm text-slate-600 max-w-md">{t("categories.subtitle")}</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5" data-testid="category-grid">
          {CATEGORIES.map((c) => {
            const Icon = getIcon(c.icon);
            return (
              <button
                key={c.key}
                data-testid={`category-${c.key.replace(/\s+/g, "-").toLowerCase()}`}
                onClick={() => onPick && onPick(c.key)}
                className="neo-card p-5 text-start flex flex-col gap-3"
              >
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center"
                  style={{ background: c.color, color: "#fff", border: "2px solid #0F172A" }}
                >
                  <Icon size={28} />
                </div>
                <div>
                  <div className="font-display text-lg font-semibold leading-tight">
                    {t(`categories.labels.${c.key}`)}
                  </div>
                  <p className="text-sm text-slate-600 mt-1">{t(`categories.desc.${c.key}`)}</p>
                </div>
                <span className="text-xs font-semibold mt-auto pt-2 text-slate-900 inline-flex items-center gap-1">
                  {t("categories.view")}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
